Vue.component('group-compare', {
	props: ['comparison_team_ids', 'group_id', 'comparison_teams'],
	
	data() {
		return {
			hidden: [],
			params: {
				travelerType: '',
				fromDate: moment().startOf('year'),
				toDate: moment(),
				source: '',
				category: '',
				reviewsType: 'ratings'
			},
			activeComparisonType: '',
			averageRatings: null,
			sentiment: null,
			reviews: null
		}
	},

	mounted() {

		this.$eventHub.$on('openComparison', (type) => this.openComparison(type))
		this.$eventHub.$on('updateCompetitionDates', (from, to) => this.updateDates(from, to))
		this.$eventHub.$on('applyCompetitionSourceFilter', (source) => this.updateSource(source))
		this.$eventHub.$on('applyCompetitionCategoryFilter', (category) => this.updateCategory(category))

	},

	computed: {
		teamIdsQuery() {

			return this.comparison_team_ids.join(',')

		},
		formattedParams() {
			let prms = this.params

			try {
				prms.toDate = prms.toDate.format("YYYY-MM-DD")
				prms.fromDate = prms.fromDate.format("YYYY-MM-DD")
			} catch(error) {
				//
			}

			return prms
		},
		
		myHotelSources() {
			if (! this.comparison_teams || this.comparison_teams.length == 0) {
				return []
			}

			return Object.keys(this.comparison_teams[0].ratings_by_source)
		},
		
		myHotelCategories() {
			if (! this.comparison_teams || this.comparison_teams.length == 0) {
				return []
			}

			return Object.keys(this.comparison_teams[0].sentiment_by_category)	
		},

		currentOutOf() {
			if (this.activeComparisonType == 'average_rating') {

				if (! this.params.source || this.params.source == '') {

					return 5

				} else {

					try {
						return this.comparison_teams[0].ratings_by_source[this.params.source].out_of
					} catch (error) {
						//
					}

				}

			} else if (this.activeComparisonType == 'sentiment') {
				return 100
			} else {
				return ''
			}

		}
	},

	methods: {
		updateDates(from, to) {
			this.params.fromDate = from
			this.params.toDate = to

			this.updateComparison(this.activeComparisonType, true)
		},

		updateSource(source) {
			this.params.source = source
			this.updateComparison(this.activeComparisonType)	
		},

		updateCategory(category) {
			this.params.category = category
			this.updateComparison(this.activeComparisonType)
		},
		
		labelize(comparison_type) {

			if (comparison_type == 'average_rating') {
				return 'AVERAGE RATING'
			}

			return comparison_type

		},
		switchComparison(type) {

			this.hidden = []
			this.activeComparisonType = type

			// Load data only if it hasn't been loaded already to allow faster
			// switching.
			if (
				(type == 'average_rating' && ! this.averageRatings) ||
				(type == 'sentiment' && ! this.sentiment) ||
				(type == 'reviews' && ! this.reviews)
			) {
				this.updateComparison(type)
			}
		},
		// Applies a source filter and updates the active comparison modal
		applySource(source) {
			this.params.source = source
			this.updateComparison(this.activeComparisonType)
		},
		// Applies a sentiment category filter
		applyCategory(category) {
			this.params.category = category
			this.updateComparison(this.activeComparisonType)
		},
		toggleDataset(index) {

			if (this.hidden.includes(index)) {
				var i = this.hidden.indexOf(index);
				if (i !== -1) this.hidden.splice(i, 1);
			} else {
				this.hidden.push(index)
			}

			this.$eventHub.$emit('toggleDataset', index)

		},
		openComparison(type) {

			this.activeComparisonType = type

			this.updateComparison(type)
		},
		updateComparison(type, new_date=false) {

			// When the date changes, we need to force-update the other
			// datasets as well.
			if (new_date) {
				this.averageRatings = null
				this.sentiment = null
				this.reviews = null
			}

			if (type == 'average_rating') {

				this.getAverageRatings()

			} else if (type == 'sentiment') {

				this.getSentiment()

			} else if (type == 'reviews') {
				
				this.getReviews()

			}
		},
		getAverageRatings() {
			let params = this.formattedParams
			params['type'] = 'competition'

			var params_string = Object.keys(params).map(function(k) {
                return params[k] == '' ? ''
                    : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
            }).join('&')

            params_string += '&team_ids=' + this.teamIdsQuery

			let url = '/api/groups/' + this.group_id + '/average-ratings'
				+ '?' + params_string

			console.log(url)

			axios.get(url)
			.then(response => {

				this.averageRatings = response.data

			}).catch(error => {
				console.log(error)
			})
		},
		getSentiment() {
			let params = this.formattedParams
			params['type'] = 'competition'

			var params_string = Object.keys(params).map(function(k) {
                return params[k] == '' ? ''
                    : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
            }).join('&')

            params_string += '&team_ids=' + this.teamIdsQuery

			let url = '/api/groups/' + this.group_id + '/sentiment'
				+ '?' + params_string

			axios.get(url)
			.then(response => {

				this.sentiment = response.data

			}).catch(error => {
				console.log(error)
			})
		},
		getReviews() {
			let params = this.formattedParams
			params['type'] = 'competition'

			var params_string = Object.keys(params).map(function(k) {
                return params[k] == '' ? ''
                    : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
            }).join('&')

            params_string += '&team_ids=' + this.teamIdsQuery

			let url = '/api/groups/' + this.group_id + '/reviews'
				+ '?' + params_string

			axios.get(url)
			.then(response => {

				this.reviews = response.data

			}).catch(error => {
				console.log(error)
			})
		},
		comparisonScore(comp) {

			if (this.activeComparisonType == 'average_rating') {

				if (! this.params.source || this.params.source == '') {
					return comp.ratings_total_average
				} else {
					return comp.ratings_by_source[this.params.source].average
				}

			} else if (this.activeComparisonType == 'sentiment') {

				if (! this.params.category || this.params.category == '') {
					return comp.sentiment_total_average
				} else {
					return comp.sentiment_by_category[this.params.category].average
				}

			} else if (this.activeComparisonType == 'reviews') {


				if (! this.params.source) {

					return comp.reviews_total_count

				} else {
					
					return comp.ratings_by_source[this.params.source].count

				}

			}

		}
	}

})
